import { render, staticRenderFns } from "./firstResultsDetail.vue?vue&type=template&id=6289bcb5&scoped=true&"
import script from "./firstResultsDetail.vue?vue&type=script&lang=js&"
export * from "./firstResultsDetail.vue?vue&type=script&lang=js&"
import style0 from "./firstResultsDetail.vue?vue&type=style&index=0&id=6289bcb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6289bcb5",
  null
  
)

export default component.exports